import request from '@/api'

// 获取合作企业和高校
export async function getCooperatorList(data) {
  return request({
    url: '/capi/web-service/cooperatorController/getList',
    method: 'post',
    data
  })
}
